module.exports = __webpack_public_path__ + "assets/74688aae81808440b2acc1d7b1a36da8.png";